/* tslint:disable */
/* eslint-disable */
/**
 * Scality Guardian Backend
 *
 * The version of the OpenAPI document: 0.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RenderedBox } from './RenderedBox';
import {
    RenderedBoxFromJSON,
    RenderedBoxFromJSONTyped,
    RenderedBoxToJSON,
    RenderedBoxToJSONTyped,
} from './RenderedBox';
import type { UiComponent } from './UiComponent';
import {
    UiComponentFromJSON,
    UiComponentFromJSONTyped,
    UiComponentToJSON,
    UiComponentToJSONTyped,
} from './UiComponent';

/**
 * 
 * @export
 * @interface RenderedBoxChildrenInner
 */
export interface RenderedBoxChildrenInner {
    /**
     * 
     * @type {string}
     * @memberof RenderedBoxChildrenInner
     */
    type: string;
    /**
     * 
     * @type {string}
     * @memberof RenderedBoxChildrenInner
     */
    title?: string;
    /**
     * core-ui Box props / CSS style properties (e.g. flexBasis, minWidth)
     * @type {{ [key: string]: any; }}
     * @memberof RenderedBoxChildrenInner
     */
    cssProperties?: { [key: string]: any; };
    /**
     * Nested rendered nodes
     * @type {Array<RenderedBoxChildrenInner>}
     * @memberof RenderedBoxChildrenInner
     */
    children?: Array<RenderedBoxChildrenInner>;
    /**
     * 
     * @type {any}
     * @memberof RenderedBoxChildrenInner
     */
    content: any | null;
    /**
     * 
     * @type {string}
     * @memberof RenderedBoxChildrenInner
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof RenderedBoxChildrenInner
     */
    metricName?: string;
}

/**
 * Check if a given object implements the RenderedBoxChildrenInner interface.
 */
export function instanceOfRenderedBoxChildrenInner(value: object): value is RenderedBoxChildrenInner {
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function RenderedBoxChildrenInnerFromJSON(json: any): RenderedBoxChildrenInner {
    return RenderedBoxChildrenInnerFromJSONTyped(json, false);
}

export function RenderedBoxChildrenInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RenderedBoxChildrenInner {
    if (json == null) {
        return json;
    }
    return {
        
        'type': json['type'],
        'title': json['title'] == null ? undefined : json['title'],
        'cssProperties': json['cssProperties'] == null ? undefined : json['cssProperties'],
        'children': json['children'] == null ? undefined : ((json['children'] as Array<any>).map(RenderedBoxChildrenInnerFromJSON)),
        'content': json['content'],
        'id': json['id'] == null ? undefined : json['id'],
        'metricName': json['metric_name'] == null ? undefined : json['metric_name'],
    };
}

export function RenderedBoxChildrenInnerToJSON(json: any): RenderedBoxChildrenInner {
    return RenderedBoxChildrenInnerToJSONTyped(json, false);
}

export function RenderedBoxChildrenInnerToJSONTyped(value?: RenderedBoxChildrenInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'type': value['type'],
        'title': value['title'],
        'cssProperties': value['cssProperties'],
        'children': value['children'] == null ? undefined : ((value['children'] as Array<any>).map(RenderedBoxChildrenInnerToJSON)),
        'content': value['content'],
        'id': value['id'],
        'metric_name': value['metricName'],
    };
}

